var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgnitionState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 295.239 295.239",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.952,200h9.524v-28.571h23.81V123.81H176.19V28.571h-14.286V0H123.81v28.571h-14.286v95.238H71.429v47.619h23.81V200 h9.524v66.667h23.81v14.286h23.81v-14.286h4.762v4.738c-0.029,2.391-0.843,14.31-14.286,14.31h-14.286v9.524h14.286 c18.833,0,23.81-15.576,23.81-23.81v-4.762h14.283V200z M176.19,133.334h28.571v28.571H176.19V133.334z M133.333,9.524h19.048 v19.048h-19.048V9.524z M119.048,114.286h9.524v-9.524h-9.524v-9.524h9.524v-9.524h-9.524V76.19h9.524v-9.524h-9.524v-9.524 h9.524v-9.524h-9.524v-9.524h47.619v9.524h-9.524v9.524h9.524v9.524h-9.524v9.524h9.524v9.524h-9.524v9.524h9.524v9.524h-9.524 v9.524h9.524v9.524h-47.619V114.286z M166.667,133.333v28.571h-47.619v-28.571H166.667z M80.952,161.904v-28.571h28.571v28.571 H80.952z M104.762,190.477v-19.048h76.19v19.048H104.762z M114.286,257.142v-7.971l27.91,7.971H114.286z M142.857,271.429h-4.762 v-4.762h4.762V271.429z M171.429,255.596l-57.143-16.329v-9.143l57.143,16.329V255.596z M171.429,236.543l-57.143-16.329v-9.143 l57.143,16.329V236.543z M171.429,217.495l-57.143-16.329V200h57.143V217.495z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.095,
    y: 104.762,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.095,
    y: 85.714,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.429,
    y: 285.714,
    width: 23.81,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.109,
    y: 264.276,
    transform: "matrix(0.7433 -0.669 0.669 0.7433 -113.9676 241.0923)",
    width: 64.07,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.852,
    y: 245.243,
    transform: "matrix(0.6357 -0.7719 0.7719 0.6357 -114.9216 256.4826)",
    width: 104.866,
    height: 9.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.667,
    width: 9.524,
    height: 76.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.619,
    y: 38.095,
    width: 9.524,
    height: 38.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.619,
    y: 85.714,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    y: 285.714,
    width: 23.81,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.057,
    y: 264.291,
    transform: "matrix(-0.7433 -0.669 0.669 -0.7433 -113.5856 494.5171)",
    width: 64.07,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.521,
    y: 245.241,
    transform: "matrix(-0.6357 -0.7719 0.7719 -0.6357 -60.5632 471.42)",
    width: 104.866,
    height: 9.519
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnitionState);
export default __webpack_public_path__ + "static/media/ignitionState.eda4df51e86975920a949ef5e9a72cfa.svg";
export { ForwardRef as ReactComponent };